/**
 * studysync design tokens (frontend mirror of newbackend/src/services/copilotTokens.js).
 * Keep the hex values in lockstep — copilotTokens.test.js fails on drift.
 */
export const tokens = {
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  brand: { cardinal: '#8C1515' },
  series: ['#0f766e', '#2563eb', '#d97706', '#7c3aed', '#0891b2', '#65a30d'],
  sequential: ['#fef2f2', '#fca5a5', '#ef4444', '#8C1515'],
  diverging: ['#0f766e', '#f1f5f9', '#dc2626'],
  semantic: { success: '#16a34a', warning: '#d97706', danger: '#dc2626', neutral: '#64748b' },
  surface: { page: '#f8fafc', card: '#ffffff', border: '#e5e7eb', grid: '#e5e7eb' },
  text: { primary: '#0f172a', secondary: '#475569', muted: '#64748b' },
} as const;
